import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const DropDownContainer = styled.div`
  position: relative;
  cursor: pointer;
`;

const DropDownHeader = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #3b3f51;
  display: flex;
  align-items: center;
  white-space: nowrap;
  & span {
    font-size: 16px !important;
    font-weight: 600 !important;
    transform: ${(props) => (props.isOpen ? 'rotateZ(180deg)' : 'rotateZ(0deg)')};
    transition: transform 0.5s cubic-bezier(0.465, 0.183, 0.153, 0.946);
  }
`;

const DropDownListContainer = styled.div``;

const DropDownList = styled.ul`
  font-size: 12px;
  font-weight: 400;
  color: #3b3f51;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 1px 1px 4px 0 rgb(0 0 0 / 10%);
  background: #fff;
  text-align: center;
`;

const ListItem = styled.li`
  list-style: none;
  padding: 6px 8px;
  white-space: nowrap;
  &:hover {
    background-color: #f4f4f4;
  }
`;

export const Dropdown = ({ options, setSelection, label, dropDowFilter }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');

  const onOptionSelected = (value) => () => {
    setIsOpen(false);
    setSelection(value.value);
    setSelectedOption(value.label);
    dropDowFilter(value);
  };

  useEffect(() => {
    setSelectedOption(options[0].label);
    setSelection(options[0].value);
  }, []);

  return (
    <DropDownContainer>
      <DropDownHeader isOpen={isOpen} onClick={() => setIsOpen((prev) => !prev)}>
        {selectedOption}
        <span className='hr-Carret-down' /> {label}
      </DropDownHeader>
      {isOpen && (
        <DropDownListContainer>
          <DropDownList>
            {options.map((option) => (
              <ListItem onClick={onOptionSelected(option)} key={option.value}>
                {option.label}
              </ListItem>
            ))}
          </DropDownList>
        </DropDownListContainer>
      )}
    </DropDownContainer>
  );
};
